import { HTTP_STATUS_FORBIDDEN } from '../../../../../constants/api'
import {
  CHARACTER_WHITESPACE,
  EMPTY_LIST,
  EMPTY_OBJECT,
} from '../../../../../constants/common'
import { isApiSuccessStatus } from '../../../../../utils/api'
import {
  getMassActionExcludeIdParam,
  getMassActionIdParam,
} from '../../../../../utils/common'
import { getViewingObjectName } from '../../../../RentalPortalViewing'
import {
  VIEWING_ACTION_ARCHIVE,
  VIEWING_ACTION_ARCHIVE_MASS,
  VIEWING_MASS_ACTION_NAMES,
} from '../../RentalPortalViewings.constants'
import { getIsViewingArchivable } from '../../RentalPortalViewings.utils'

import { VIEWING_SINGLE_ACTION_BY_MASS_ACTION } from './useRentalPortalViewingsMassActions.constants'

function getViewingsMassActionActSentence({
  eligibleItems,
  locale,
  t,
  timezone,
}) {
  return eligibleItems.length === 1
    ? t('RentalPortal.ViewingArchiveConfirmationTextKey', {
        name: getViewingObjectName({
          locale,
          t,
          timezone,
          viewing: eligibleItems[0],
        }),
      })
    : t('RentalPortal.ViewingArchiveMassConfirmationTextKey', {
        count: eligibleItems.length,
      })
}

export function getViewingsMassActionRequest({
  action,
  eligibleIds,
  excludeIds,
  filterValues,
  ids,
  selectAllPages,
}) {
  const isAllPages = selectAllPages && (ids?.length ?? 0) === 0

  return {
    action: VIEWING_MASS_ACTION_NAMES[action],
    all: isAllPages,
    filters: {
      ...filterValues,
      exclude_id:
        getMassActionExcludeIdParam({
          excludeIds,
          selectAllPages: isAllPages,
        }) ?? EMPTY_LIST,
      id:
        getMassActionIdParam({
          ids,
          selectAllPages: isAllPages,
          selectedIds: eligibleIds,
        }) ?? EMPTY_LIST,
    },
    payload: EMPTY_OBJECT,
  }
}

export function getViewingsMassActionItems({
  allItems,
  excludeIds,
  selectAllPages,
  selected,
}) {
  return selectAllPages
    ? allItems.filter(viewing => !excludeIds.includes(viewing.id))
    : selected
}

export function getViewingsMassActionEligibleItems(items) {
  return items.filter(getIsViewingArchivable)
}

export function getViewingsMassActionFailures({
  items,
  locale,
  resultItems,
  t,
  timezone,
}) {
  const failedItems = resultItems.filter(
    resultItem => !isApiSuccessStatus(resultItem.status_code)
  )

  return {
    count: failedItems.length,
    isNotAllowed:
      failedItems.length > 0 &&
      failedItems.every(
        resultItem => resultItem.status_code === HTTP_STATUS_FORBIDDEN
      ),
    names: failedItems
      .map(resultItem => {
        const viewing = items.find(item => item.id === resultItem.id)

        return viewing
          ? getViewingObjectName({ locale, t, timezone, viewing })
          : null
      })
      .filter(Boolean),
  }
}

export function getViewingsMassActionFailureText({ failures, t }) {
  return failures.names.length === failures.count
    ? t(
        failures.isNotAllowed
          ? 'RentalPortal.ListingMassActionNotAllowedItemsKey'
          : 'RentalPortal.ListingMassActionFailedItemsKey',
        { names: failures.names.join(', ') }
      )
    : t(
        failures.isNotAllowed
          ? 'RentalPortal.ViewingMassActionNotAllowedCountKey'
          : 'RentalPortal.ViewingMassActionFailedCountKey',
        { count: failures.count }
      )
}

export function getNotificationTitle({ action, count, t, totalCount }) {
  const titleAction =
    totalCount > 1
      ? action
      : (VIEWING_SINGLE_ACTION_BY_MASS_ACTION[action] ?? action)

  const titles = {
    [VIEWING_ACTION_ARCHIVE]: t('Notification.CommonTitleArchivedKey'),
    [VIEWING_ACTION_ARCHIVE_MASS]: t(
      'Notification.CommonTitleMassArchivedKey',
      {
        count,
        totalCount,
      }
    ),
  }

  return titles[titleAction] || null
}

export function getViewingsMassActionDescription({
  eligibleItems,
  locale,
  selectedCount,
  t,
  timezone,
}) {
  const sentences = [
    getViewingsMassActionActSentence({ eligibleItems, locale, t, timezone }),
    eligibleItems.length < selectedCount
      ? t('RentalPortal.ViewingArchiveMassMixedEligibilityKey', {
          eligible: eligibleItems.length,
          selected: selectedCount,
        })
      : null,
  ]

  return sentences.filter(Boolean).join(CHARACTER_WHITESPACE)
}
